import { useMemo } from "react"

import { Sliders } from "../components/Sliders/Slider"
import { MyStagePageQuery } from "../generated/graphql"
import { appStore } from "../store/AppStore"
import { ArrayElement } from "../types"
import { maxSliderSize } from "../utilities/constants"

import { MystageSliderId } from "./use-browse-screen"
import useIntl from "./use-intl"
import { useMystageSliders } from "./use-mystage-sliders"
import useTranslate from "./use-translate"

export type MyStageSliders = (ArrayElement<Sliders> | undefined)[]

export const useMystageScreen = (data?: MyStagePageQuery) => {
  const { dateFormat } = useIntl()
  const t = useTranslate()
  const geoInfo = appStore((state) => state.geoInfo)

  const videoSlider = data?.currentUser?.videoRecentlyPlayed
  const videoRecentlyResult = useMystageSliders(
    MystageSliderId.RecentlyPlayedVideo,
    t("tv__myStage_headline_recent_videos"),
    videoSlider,
  )
  const albumSlider = data?.currentUser?.albumRecentlyPlayed

  const albumRecentlyResult = useMystageSliders(
    MystageSliderId.RecentlyPlayedAudio,
    t("tv__myStage_headline_recent_albums"),
    albumSlider,
  )
  const videoFavorites = data?.currentUser?.videoFavorites
  const albumFavorites = data?.currentUser?.albumFavorites
  const editorialPlaylistFavorites =
    data?.currentUser?.editorialPlaylistFavorites
  const videoFavoritesResult = useMystageSliders(
    MystageSliderId.FavoriteVideo,
    t("tv__myStage_headline_favourite_videos"),
    videoFavorites,
  )
  const albumFavoritesResult = useMystageSliders(
    MystageSliderId.FavoriteAudio,
    t("tv__myStage_headline_favourite_albums"),
    albumFavorites,
  )
  const editorialPlaylistFavoritesResult = useMystageSliders(
    MystageSliderId.FavoriteEditorialPlaylist,
    t("tv__myStage_headline_favourite_playlists"),
    editorialPlaylistFavorites,
  )
  const result = useMemo<MyStageSliders>(() => {
    if (
      albumRecentlyResult?.teasers.length &&
      albumRecentlyResult?.teasers.length > maxSliderSize
    )
      albumRecentlyResult.pageInfo.hasNextPage = true

    return [
      videoFavoritesResult,
      videoRecentlyResult,
      albumFavoritesResult,
      albumRecentlyResult,
      editorialPlaylistFavoritesResult,
    ]
  }, [data, dateFormat, t, geoInfo])

  return { sliders: result }
}
